<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['no']" placeholder="business.label.printNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['name']" placeholder="business.label.printName" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
        <vxe-button content="button.save" icon="vxe-icon-save" status="success" @click="save"/>
        <vxe-button content="button.uploadTemplate" icon="vxe-icon-upload" status="warning" @click="uploadTemplate"/>
      </template>
      <vxe-table
        ref="table"
        :data="data"
        :edit-config="{}"
        :edit-rules="editRules"
        :loading="loading"
        keep-source>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="no" title="business.label.no" width="150"/>
        <vxe-column :edit-render="{name:'VxeInput',autoSelect:true}" field="name" title="business.label.name" width="200"/>
        <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="70"/>
        <vxe-column :cell-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('statementModal',row.statement,row)}}" field="statement" title="business.label.printStatement"/>
        <vxe-column :edit-render="{name:'VxeInput',props:{readonly:true},events:{click:({row})=>openModal('templateModal',row.template,row)}}" field="template" title="business.label.printTemplate"/>
        <vxe-column :cell-render="{name:'VxeNumberInput',props:{min:1},autoSelect:true}" field="paperLength" title="business.label.paperLength" width="80"/>
        <vxe-column :cell-render="{name:'VxeNumberInput',props:{min:1},autoSelect:true}" field="paperWidth" title="business.label.paperWidth" width="80"/>
        <vxe-column :cell-render="{name:'VxeNumberInput',props:{min:1},autoSelect:true}" field="paperSize" title="business.label.paperSize" width="80"/>
        <vxe-column field="enterprise.name" title="business.label.enterprise" width="100"/>
        <vxe-column field="warehouse.name" title="business.label.warehouse" width="100"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="business.label.config" icon="vxe-icon-association-form" status="primary" @click.stop="config(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <TextAreaModal ref="statementModal" title="打印语句" @change="(e,row)=>{row.statement = e}"/>
    <TextAreaModal ref="templateModal" title="打印模板" @change="(e,row)=>{row.template = e}"/>
  </div>
</template>

<script>
import { findAll, saveAll } from '@/api/Api'
import TextAreaModal from '@/views/modal/TextAreaModal.vue'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { Print } from '@/api/dto/admin/Print'

export default {
  name: 'PrintTable',
  components: {
    TextAreaModal
  },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      query: { no: '', name: '' },
      page: 1,
      size: 20,
      contentSize: 0,
      editRules: {
        no: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        statement: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        template: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    dblclick(row) {
      if (!this.$refs.table.isEditByRow(row)) {
        this.$emit('dblClick', row)
      }
    },
    openModal(modal, args, e) {
      this.$refs[modal].open(args, e)
    },
    fetch() {
      this.loading = true
      findAll('printFactory', this.query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new Print(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = { no: '', name: '' }
      this.refresh()
    },
    add() {
      this.data.push(new Print())
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          return item.toJSONObject()
        })
        saveAll('printPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.saveSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    uploadTemplate() {
    },
    config(row) {
      this.$emit('config', new Print(row))
    }
  }
}
</script>